import { Route } from '@angular/router';
import { Path } from '../../../common/constants/paths.constant';
import { rfqDetailsResolver } from '../../../common/resolvers/rfq-details.resolver';
import { quotationDetailsResolver } from '../../../common/resolvers/quotation-details/quotation-details.resolver';
import { poDetailsResolver } from '../../../common/resolvers/po-details/po-details.resolver';
import { rfpDetailsResolver } from '../../../common/resolvers/rfp-details.resolver';
import { quotationRFPDetailsResolver } from '../../../common/resolvers/quotation-rfp-details.resolver';
import { poRFPDetailsResolver } from '../../../common/resolvers/po-rfp-details.resolver';

export const buyerRoutes: Route[] = [
  {
    path: '',
    redirectTo: `/${localStorage.getItem('lang') ?? 'ar'}/${Path.BUYER}/${Path.DASHBOARD}`,
    pathMatch: 'full',
  },
  {
    path: Path.DASHBOARD,
    loadComponent: () =>
      import('../../../pages/dashboard/buyer/dashboard/dashboard.component').then(
        c => c.DashboardComponent
      ),
  },
  {
    path: Path.PROJECTS,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/projects/projects.component').then(
            c => c.ProjectsComponent
          ),
      },
      {
        path: ':projectId',
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/projects/project-details/project-details.component').then(
            c => c.ProjectDetailsComponent
          ),
      },
    ],
  },
  {
    path: Path.RFQ.RFQ,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/rfq-board/rfq-board.component').then(
            c => c.RfqBoardComponent
          ),
      },
      {
        path: `${Path.RFQ.FORM}`,
        data: { role: 'buyer' },
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/rfq-form/rfq-form.component').then(
            c => c.RfqFormComponent
          ),
      },
      {
        path: `${Path.RFQ.FORM}/:rfqId`,
        data: { role: 'buyer' },
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/rfq-form/rfq-form.component').then(
            c => c.RfqFormComponent
          ),
        resolve: {
          rfqDetails: rfqDetailsResolver,
        },
      },
      {
        path: `${Path.RFQ.DETAILS}/:rfqId`,
        data: { role: 'buyer' },
        loadComponent: () =>
          import('../../../common/components/rfq-details-view/rfq-details-view.component').then(
            c => c.RfqDetailsViewComponent
          ),
        resolve: {
          rfqDetails: rfqDetailsResolver,
        },
      },
      {
        path: Path.RFQ.COMPARISON,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/quotations/rfq/quotation-comparison/quotation-comparison.component').then(
            c => c.QuotationComparisonComponent
          ),
      },
      {
        path: `${Path.RFQ.SUPPLIER_DETAILS}/:supplierId`,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/supplier-details/supplier-details.component').then(
            c => c.SupplierDetailsComponent
          ),
      },
    ],
  },

  {
    path: Path.RFP.RFP,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./rfp/rfp-board.component').then(c => c.RfpBoardComponent),
      },
      {
        path: `${Path.RFP.FORM}`,
        data: { role: 'buyer' },
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/rfp/rfp-form/rfp-form.component').then(
            c => c.RfpFormComponent
          ),
      },
      {
        path: `${Path.RFP.FORM}/:rfpId`,
        data: { role: 'buyer' },
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/rfp/rfp-form/rfp-form.component').then(
            c => c.RfpFormComponent
          ),
        resolve: {
          rfpDetails: rfpDetailsResolver,
        },
      },
      {
        path: `${Path.RFP.DETAILS}/:rfpId`,
        data: { role: 'buyer' },
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/rfp/rfp-details/rfp-details.component').then(
            c => c.RfpDetailsComponent
          ),
        resolve: {
          rfpDetails: rfpDetailsResolver,
        },
      },
      {
        path: Path.RFP.COMPARISON,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/quotations/rfp/quotation-comparison/quotation-comparison.component').then(
            c => c.QuotationComparisonComponent
          ),
      },
      {
        path: `${Path.RFP.CONTRACTOR_DETAILS}/:contractorId`,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/contractor-details/contractor-details.component').then(
            c => c.ContractorDetailsComponent
          ),
      },
    ],
  },

  {
    path: Path.QUOTATION.QUOTATION_RFQ,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./quotations/rfq/quotations.component').then(
            C => C.QuotationsComponent
          ),
      },
      {
        path: `${Path.QUOTATION.DETAILS}/:rfqId/:quotationId`,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/quotations/rfq/quotation-details-view/quotation-details-view.component').then(
            c => c.QuotationDetailsViewComponent
          ),
        resolve: { quotationDetails: quotationDetailsResolver },
      },
      {
        path: Path.QUOTATION.AWARDED,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/quotations/rfq/quotation-awarded/quotation-awarded.component').then(
            c => c.QuotationAwardedComponent
          ),
      },
    ],
  },
  {
    path: Path.QUOTATION.QUOTATION_RFP,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./quotations/rfp/quotations.component').then(
            C => C.QuotationsComponent
          ),
      },
      {
        path: `${Path.QUOTATION.DETAILS}/:rfpId/:quotationId`,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/quotations/rfp/quotation-details-view/quotation-details-view.component').then(
            c => c.QuotationDetailsViewComponent
          ),
        resolve: { quotationRFPDetails: quotationRFPDetailsResolver },
      },
      {
        path: Path.QUOTATION.AWARDED,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/quotations/rfp/quotation-awarded/quotation-awarded.component').then(
            c => c.QuotationAwardedComponent
          ),
      },
    ],
  },

  {
    path: Path.PO.PO_RFQ,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/po/rfq/po.component').then(
            c => c.PoComponent
          ),
      },
      {
        path: `${Path.PO.DETAILS}/:id`,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/po/rfq/po-details-view/po-details-view.component').then(
            c => c.PoDetailsViewComponent
          ),
        resolve: {
          poDetails: poDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.PO.PO_RFP,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/po/rfp/po.component').then(
            c => c.PoComponent
          ),
      },
      {
        path: `${Path.PO.DETAILS}/:id`,
        loadComponent: () =>
          import('../../../pages/dashboard/buyer/po/rfp/po-details-view/po-details-view.component').then(
            c => c.PoDetailsViewComponent
          ),
        resolve: {
          poDetails: poRFPDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.ACCOUNT,
    loadComponent: () =>
      import('../../../pages/dashboard/buyer/buyer-account/buyer-account.component').then(
        c => c.BuyerAccountComponent
      ),
  },
];
